import ErrorPage from '../ErrorPage';

const UnknownError = () => {
    return <ErrorPage
        title='Unknown Error'
        heading='Oops! There was an unexpected error.'
        description='It looks like there was some unexpected error when viewing the page at this location.'/>
};

export default UnknownError;
